<script>
export default {
  name: "DidoMillesimeTableRowExtendedFilters",
};
</script>

<script setup>
import { ref, computed, watch } from "vue";
import api from "../../../../api";
import DidoMillesimeInputFilterWrapper from "../../filters/Wrapper.vue";

// define Props
const props = defineProps({
  show: { type: Boolean, required: true },
  apiUrl: { type: String, required: true },
  visibleColumns: { type: Array, required: true },
  availableFiltersInGroups: { type: Array, required: true },
  modelValue: { type: Object, required: true },
});

// define Emits
const emit = defineEmits(["update:model-value"]);

// define reactive data and watcher from props for activeFilters
const activeFilters = ref(props.modelValue);
watch(
  () => props.modelValue,
  () => (activeFilters.value = props.modelValue),
);

// define computed data
const groupedColumns = computed(() =>
  props.visibleColumns.reduce((currentGroupedColumns, visibleColumn) => {
    const newGroupedColumns = [...currentGroupedColumns];
    const extendedFilter = props.availableFiltersInGroups.find((filter) =>
      filter.columns.includes(visibleColumn),
    );
    if (!extendedFilter) {
      newGroupedColumns.push({
        columns: 1,
        name: null,
        tdclass: "",
      });
    } else {
      const indexGroup = newGroupedColumns.findIndex(
        (group) => group.name === extendedFilter.name,
      );
      if (indexGroup > -1) {
        newGroupedColumns[indexGroup].columns += 1;
      } else {
        newGroupedColumns.push({
          columns: 1,
          name: extendedFilter.name,
          filters: props.availableFiltersInGroups.find(
            (filter) => filter.name === extendedFilter.name,
          ).filters,
          tdclass: "bg-grey-2 text-secondary",
        });
      }
    }
    return newGroupedColumns;
  }, []),
);

const show = computed(
  () => props.show && groupedColumns.value.filter(({ name }) => !!name).length,
);

// define method for specs of groups
const specsOfGroup = (groupName) =>
  props.availableFiltersInGroups.find(({ name }) => name === groupName);

// define method for available filters in column as list options
const availableFiltersInGroup = (groupName) =>
  specsOfGroup(groupName).filters.map((filterName) => ({
    label: api.filters[filterName],
    value: filterName,
  }));
</script>

<template>
  <QTr v-if="show">
    <QTd
      v-for="(group, index) in groupedColumns"
      :key="`extendedFilters-${index}`"
      :colspan="group.columns"
      :class="group.tdclass"
    >
      <QSelect
        v-if="activeFilters[group.name]"
        v-model="activeFilters[group.name].type"
        dense
        options-dense
        square
        outlined
        :options="availableFiltersInGroup(group.name)"
        class="dido-millesime-table-row-extendedfilters-cell-filterselect"
        clearable
        clear-icon="mdi-close"
        emit-value
        map-options
        @update:model-value="[
          (activeFilters[group.name].value = ''),
          emit('update:model-value', activeFilters),
        ]"
      />
      <DidoMillesimeInputFilterWrapper
        v-if="activeFilters[group.name]"
        v-model="activeFilters[group.name].value"
        :filter="activeFilters[group.name].type"
        :is-number="false"
        :api-url="props.apiUrl"
        @update:model-value="[
          (activeFilters[group.name].value = $event),
          emit('update:model-value', activeFilters),
        ]"
      />
    </QTd>
  </QTr>
</template>

<style lang="sass" scoped>
.dido-millesime-table-row-extendedfilters-cell-filterselect
  min-width: 150px
</style>
